import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAutomationTemplateQuery } from '../../queries/useAutomationTemplateQuery';

interface Params {
	templateId: string;
	stepId: string;
	attachmentId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useRemoveTextingStepAttachmentMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ITextingAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ templateId, stepId, attachmentId, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.ITextingAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Texting/${encodeURIComponent(
						stepId
					)}/Attachment/${encodeURIComponent(attachmentId)}`,
					impersonationContext,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateAutomationTemplateQuery(variables.templateId);
			onSuccess?.(data, variables);
		},
	});
}
